import { customTv } from "#utils";

export const boxStyles = customTv({
  base: "w-4 h-4 shrink-0 rounded-[.125rem] flex items-center justify-center border transition",
  variants: {
    isSelected: {
      false: "bg-background-primary border-outline-input-enabled focus:border-outline-input-focus",
      true: "bg-brand-primary border-brand-primary focus:bg-interactive-primary-button-focus-background",
    },
    isInvalid: {
      true: "text-text-negative border-text-negative",
    },
    isDisabled: {
      true: "border-interactive-disabled-outline",
    },
    isHovered: {
      true: "",
    },
    isFocused: {
      true: "",
    },
  },
  compoundVariants: [
    // Unselected
    {
      isSelected: false,
      isHovered: true,
      class: "border-outline-input-hover",
    },
    {
      isSelected: false,
      isFocused: true,
      class: "border-outline-input-focus",
    },

    // Selected
    {
      isSelected: true,
      isHovered: true,
      class:
        "bg-interactive-primary-button-hover-background border-interactive-primary-button-hover-background",
    },
    {
      isSelected: true,
      isFocused: true,
      class:
        "bg-interactive-primary-button-focus-background border-interactive-primary-button-focus-background",
    },

    // Invalid
    {
      isInvalid: true,
      isHovered: true,
      class: "border-outline-input-hover",
    },
    {
      isInvalid: true,
      isFocused: true,
      class: "border-outline-input-focus",
    },
    {
      isInvalid: true,
      isSelected: true,
      class: "bg-text-negative",
    },
    {
      isInvalid: true,
      isSelected: true,
      isHovered: true,
      class:
        "bg-interactive-primary-button-hover-background border-interactive-primary-button-hover-background",
    },
    {
      isInvalid: true,
      isSelected: true,
      isFocused: true,
      class:
        "bg-interactive-primary-button-focus-background border-interactive-primary-button-focus-background",
    },

    // Disabled
    {
      isDisabled: true,
      isSelected: true,
      class:
        "bg-interactive-secondary-button-focus-background border-interactive-secondary-button-focus-background",
    },
  ],
});
